import React from 'react';
import Header from '../../components/ui/Header';
import ContactHero from './components/ContactHero';
import ContactRouting from './components/ContactRouting';
import ContactForm from './components/ContactForm';
import LiveChatWidget from './components/LiveChatWidget';
import SupportResources from './components/SupportResources';
import OfficeLocations from './components/OfficeLocations';
import TeamDirectory from './components/TeamDirectory';
import SocialMediaIntegration from './components/SocialMediaIntegration';

const ContactSupport = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-16">
        {/* <ContactHero /> */}
        <ContactRouting />
        <ContactForm />
        {/* <SupportResources />
        <OfficeLocations />
        <TeamDirectory />
        <SocialMediaIntegration /> */}
      </main>

      {/* <LiveChatWidget /> */}

        <footer className="bg-primary border-t border-border">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="grid md:grid-cols-4 gap-8">
              {/* Company Info */}
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-accent to-cyber-purple flex items-center justify-center">
                    <span className="text-white font-bold text-sm">DC</span>
                  </div>
                  <span className="text-lg font-bold text-foreground">Dream Coders Club</span>
                </div>
                <p className="text-muted-foreground text-sm">
                  Transforming education through AI and Robotics innovation. Building tomorrow's workforce today.
                </p>
              </div>

              {/* Solutions */}
              <div>
                <h3 className="text-foreground font-semibold mb-4">Follow Us</h3>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li><a href="https://www.linkedin.com/company/dreamcodersclub" target = "_blank" className="hover:text-accent transition-colors">LinkedIn</a></li>
                  {/* <li><a href="#" className="hover:text-accent transition-colors">Corporate Training</a></li>
                  <li><a href="#" className="hover:text-accent transition-colors">Government Programs</a></li>
                  <li><a href="#" className="hover:text-accent transition-colors">Custom Solutions</a></li> */}
                </ul>
              </div>

              {/* Resources */}
              <div>
                <h3 className="text-foreground font-semibold mb-4">Free Resources</h3>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li><a href="#" className="hover:text-accent transition-colors">Python Beginner's Guide</a></li>
                  {/* <li><a href="#" className="hover:text-accent transition-colors">Case Studies</a></li>
                  <li><a href="#" className="hover:text-accent transition-colors">ROI Calculator</a></li>
                  <li><a href="#" className="hover:text-accent transition-colors">Industry Reports</a></li> */}
                </ul>
              </div>

              {/* Contact */}
              <div>
                <h3 className="text-foreground font-semibold mb-4">Contact</h3>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li>dreamcodersclub99@gmail.com</li>
                  <li>+91 99208 85753</li>
                </ul>
              </div>
            </div>

            <div className="border-t border-border mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
              <p className="text-sm text-muted-foreground">
                © {new Date().getFullYear()} Clusterize Learning LLP. All rights reserved.
              </p>
              {/* <div className="flex space-x-6 mt-4 md:mt-0">
                <a href="#" className="text-sm text-muted-foreground hover:text-accent transition-colors">Privacy Policy</a>
                <a href="#" className="text-sm text-muted-foreground hover:text-accent transition-colors">Terms of Service</a>
                <a href="#" className="text-sm text-muted-foreground hover:text-accent transition-colors">Security</a>
              </div> */}
            </div>
          </div>
        </footer>
    </div>
  );
};

export default ContactSupport;